import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29606a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "b-modal"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b-modal__backdrop" }, null, -1))

import { CSSProperties, PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Base',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: 'var(--neutral-bg-default)',
    },
    width: {
      type: String as PropType<CSSProperties['width']>,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modalV2" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", {
                class: "b-modal__content",
                style: _normalizeStyle({ background: __props.bg, width: __props.width })
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 4)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})